"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Url = (function () {
    function Url(url) {
        this.url = url;
        this.url = url;
    }
    Url.prototype.toJSON = function () {
        return this.url;
    };
    Url.prototype.toString = function () {
        return this.url;
    };
    return Url;
}());
exports.Url = Url;
//# sourceMappingURL=Url.js.map